import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethod } from '@frontend';

@Pipe({
  name: 'paymentMethodImage'
})
export class PaymentMethodImagePipe implements PipeTransform {
  transform(paymentMethodName: PaymentMethod): string {
    switch (paymentMethodName) {
      case PaymentMethod.mastercard:
        return 'images/payments/on-card/methods/mastercard.svg';
      case PaymentMethod.visa:
        return 'images/payments/on-card/methods/visa.svg';
      case PaymentMethod.diners:
        return 'images/payments/on-card/methods/diners.svg';
      case PaymentMethod.maestro:
        return 'images/payments/on-card/methods/maestro.svg';
      case PaymentMethod.paypal:
        return 'images/payments/on-card/methods/paypal.svg';
      case PaymentMethod.sofort:
        return 'images/payments/on-card/methods/sofort.svg';
      case PaymentMethod.applepay:
        return 'images/payments/on-card/methods/applepay.svg';
      case PaymentMethod.giropay:
        return 'images/payments/on-card/methods/giropay.svg';
      case PaymentMethod.ideal:
        return 'images/payments/on-card/methods/ideal.svg';
      case PaymentMethod.postfinance:
        return 'images/payments/on-card/methods/postfinance.svg';
      case PaymentMethod.directdebit:
        return 'images/payments/on-card/methods/directdebit.svg';
      case PaymentMethod.cartesbancaires:
        return 'images/payments/on-card/methods/cartesbancaires.svg';
      case PaymentMethod.accounttoaccount:
        return 'images/payments/bank-transfer.png';
      default:
        return '';
    }
  }
}
